import { useRef } from "react";
import { uploadChangeHandler } from "@ts/bulk-taxonomy";
import { IUploadExcelFile } from "@ts/common-types";
import { FaUpload } from "react-icons/fa";

interface IAssetUploadComponent {
    setUploadExcelFile: React.Dispatch<React.SetStateAction<IUploadExcelFile>>;
}

const AssetUploadComponent: React.FC<IAssetUploadComponent> = ({
    setUploadExcelFile,
}) => {
    const inputRef = useRef<HTMLInputElement>(null);

    const onButtonClick = (e: React.MouseEvent) => {
        e.preventDefault();
        inputRef.current.click();
    };

    const handleDrag = (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
    };

    const handleDrop = (
        e: React.DragEvent<HTMLDivElement | HTMLFormElement>
    ) => {
        e.preventDefault();
        e.stopPropagation();
        if (e.dataTransfer.files && e.dataTransfer.files[0]) {
            setUploadExcelFile(e.dataTransfer.files[0]);
        }
    };

    return (
        <>
            <div>
                <form
                    id="file-upload-form"
                    className="uploader"
                    onDragEnter={handleDrag}
                    onDragLeave={handleDrag}
                    onDragOver={handleDrag}
                    onDrop={handleDrop}
                    onSubmit={(e) => e.preventDefault()}
                >
                    <input
                        ref={inputRef}
                        id="file-upload"
                        type="file"
                        name="fileUpload"
                        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                        onChange={(e) =>
                            uploadChangeHandler(e, setUploadExcelFile)
                        }
                    />
                    <label htmlFor="file-upload" id="file-drag">
                        <img
                            id="file-image"
                            src="#"
                            alt="Preview"
                            className="hidden"
                        />
                        <div id="start">
                            <FaUpload className="mb-3" style={{fontSize: "48px"}} aria-hidden="true"/>
                            <div>Select a file or drag here</div>
                            <button
                                id="file-upload-btn"
                                className="btn btn-primary"
                                type="submit"
                                onClick={onButtonClick}
                            >
                                Select a file
                            </button>
                        </div>
                    </label>
                </form>
            </div>
        </>
    );
};

export default AssetUploadComponent;
